// @core/api/endpoints/project/list_items.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListItemsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List project items
 * Returns a paginated list of project items with optional filtering by sprint, epic, assignee, or column. Includes both item metadata and source task details.
 */
export async function ListItems(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListItemsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/items`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListItemsResponse>(requestPath, { ...requestOptions, params });
}
